function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m50 23c2.2 0 4.3-0.9 5.8-2.4l0.8-0.8C57.1 17.3 58 15.2 58 13c0-0.6-0.4-1-1-1-2.2 0-4.3 0.9-5.8 2.4l-0.8 0.8C48.9 16.7 48 18.8 48 21c0 0.6 0.4 1 1 1zm2.8-5.4 0.8-0.8c0.9-0.9 2.1-1.5 3.3-1.7-0.2 1.3-0.8 2.4-1.7 3.3l-0.8 0.8c-0.9 0.9-2.1 1.5-3.3 1.7 0.2-1.3 0.8-2.4 1.7-3.3z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.2 12.6C40.7 14.1 42.8 15 45 15c0.6 0 1-0.4 1-1 0-2.2-0.9-4.3-2.4-5.8L42.8 7.4C41.3 5.9 39.2 5 37 5c-0.6 0-1 0.4-1 1 0 2.2 0.9 4.3 2.4 5.8zm2.2-3.8 0.8 0.8c0.9 0.9 1.5 2.1 1.7 3.3-1.3-0.2-2.4-0.8-3.3-1.7l-0.8-0.8c-0.9-0.9-1.5-2.1-1.7-3.3 1.3 0.2 2.4 0.8 3.3 1.7z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m21 11c2.2 0 4.3-0.9 5.8-2.4L26.6 6.8C28.1 5.3 29 3.2 29 1 29 0.4 28.6 0 28 0 25.8 0 23.7 0.9 22.2 2.4L21.4 3.2C19.9 4.7 19 6.8 19 9c0 0.6 0.4 1 1 1zm2.8-5.4 0.8-0.8c0.9-0.9 2.1-1.5 3.3-1.7-0.2 1.3-0.8 2.4-1.7 3.3l-0.8 0.8c-0.9 0.9-2.1 1.5-3.3 1.7 0.2-1.3 0.8-2.4 1.7-3.3z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m27 14c0 2.2 0.9 4.3 2.4 5.8l0.8 0.8C30.7 21.1 32.8 22 35 22c0.6 0 1-0.4 1-1 0-2.2-0.9-4.3-2.4-5.8L32.8 14.4C31.3 12.9 29.2 12 27 12c-0.6 0-1 0.4-1 1zm5.4 2.8 0.8 0.8c0.9 0.9 1.5 2.1 1.7 3.3-1.3-0.2-2.4-0.8-3.3-1.7l-0.8-0.8c-0.9-0.9-1.5-2.1-1.7-3.3 1.3 0.2 2.4 0.8 3.3 1.7z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61 30H45C45.6 28.8 46 27.4 46 26c0-0.6-0.4-1-1-1-2.2 0-4.3 0.9-5.8 2.4l-0.8 0.8C37.9 28.7 37.4 29.3 37 30H29.4L6.4 7C5.1 5.7 2.9 5.7 1.6 7L1 7.6C0.4 8.2 0 9.1 0 10c0 0.9 0.4 1.8 1 2.4L18.6 30H1c-0.6 0-1 0.4-1 1 0 17.1 13.9 31 31 31 17.1 0 31-13.9 31-31 0-0.6-0.4-1-1-1zm-1.2 4H56v-2h4c0 0.7-0.1 1.3-0.1 2zM41 36c-1.7 0-3 1.3-3 3v8c0 0.6-0.4 1-1 1-0.6 0-1-0.4-1-1V37c0-1.7-1.3-3-3-3-1.7 0-3 1.3-3 3v6c0 0.6-0.4 1-1 1-0.6 0-1-0.4-1-1V32h26v9c0 0.6-0.4 1-1 1-0.6 0-1-0.4-1-1 0-1.7-1.3-3-3-3-1.7 0-3 1.3-3 3v4c0 0.6-0.4 1-1 1-0.6 0-1-0.4-1-1v-6c0-1.7-1.3-3-3-3zm-1.2-6.4 0.8-0.8c0.9-0.9 2.1-1.5 3.3-1.7-0.2 1.1-0.7 2.1-1.4 2.9h-3c0.1-0.1 0.2-0.3 0.3-0.4zM2 10C2 9.6 2.1 9.3 2.4 9L3 8.4c0.5-0.5 1.5-0.5 2 0L7.6 11 5 13.6 2.4 11C2.1 10.7 2 10.4 2 10ZM6.4 15 9 12.4 26.6 30H21.4ZM26 32v2H2.2C2.1 33.3 2 32.7 2 32Zm5 28C16.7 60 4.8 49.6 2.4 36H26v7c0 1.7 1.3 3 3 3 1.7 0 3-1.3 3-3v-6c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1v10c0 1.7 1.3 3 3 3 1.7 0 3-1.3 3-3v-8c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1v6c0 1.7 1.3 3 3 3 1.7 0 3-1.3 3-3v-4c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1 0 1.7 1.3 3 3 3 1.7 0 3-1.3 3-3v-5h3.6C57.2 49.6 45.3 60 31 60Z"
});

var SvgIconCooking = function SvgIconCooking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cooking.add7cd60.svg";
export { ForwardRef as ReactComponent };